import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import View from '../../../../../components/pdf/View'
import { Bullets, Paragraph, SectionHeading, SubHeading } from './_shared/Prose'

/**
 * Seção 8 - Classificação dos Riscos (visão geral). Texto literal do modelo aprovado
 * por Julia Buzzo ("Modelo PGR 2026 - Banco Bradesco_Varejo"). Substitui o placeholder
 * institucional anterior (arquivo era `08.MetodologiaAIHASection.js` — o conteúdo
 * detalhado do método AIHA é a subseção 9.1, ver `09.ClassificacaoRiscosFisicoQuimicoBiologicoSection.js`).
 */
const ClassificacaoDosRiscosSection = () => (
  <View id="8">
    <Separator weight={15} />
    <SectionHeading numero={8}>CLASSIFICAÇÃO DOS RISCOS</SectionHeading>

    <Paragraph>
      Em conformidade com o disposto no item 1.5.4.4 da NR-1, o Banco Bradesco S.A. realiza a avaliação dos riscos
      ocupacionais com base nos perigos identificados em seus ambientes laborais, de forma a fornecer informações
      técnicas essenciais para a definição e priorização das medidas de prevenção.
    </Paragraph>

    <SubHeading id="8.1">8.1. Metodologia de Avaliação</SubHeading>
    <Paragraph>
      Para cada risco identificado, é determinado o nível de risco ocupacional, considerando a combinação entre:
    </Paragraph>
    <Bullets
      items={[
        'Severidade das possíveis lesões ou agravos à saúde;',
        'Probabilidade de ocorrência, considerando os fatores associados ao ambiente, ao tipo de exposição e à eficácia das medidas de controle existentes.'
      ]}
    />
    <Paragraph>
      A instituição utiliza ferramentas e técnicas adequadas à natureza e complexidade de cada risco, conforme as
      melhores práticas de avaliação técnica, respeitando os critérios normativos aplicáveis.
    </Paragraph>

    <SubHeading id="8.2">8.2. Critério de Avaliação</SubHeading>
    <Paragraph>O processo de avaliação segue critérios documentados, incluindo:</Paragraph>
    <Bullets
      items={[
        'Gradações de severidade e probabilidade;',
        'Níveis de risco (baixo, moderado, alto, muito alto, conforme matriz de risco adotada);',
        'Critérios de classificação e de tomada de decisão, utilizados para o gerenciamento de riscos ocupacionais e elaboração dos planos de ação corretiva e preventiva.'
      ]}
    />
    <Paragraph>
      Para cada perigo identificado, quando houver múltiplas consequências possíveis, considera-se a consequência de
      maior magnitude para definição da severidade.
    </Paragraph>

    <SubHeading id="8.3">8.3. Análise por Tipo de Fator de Risco</SubHeading>
    <Paragraph>A avaliação da probabilidade de ocorrência é orientada conforme o tipo de risco envolvido:</Paragraph>
    <Bullets
      items={[
        'Riscos físicos, químicos e biológicos: comparação com valores de referência previstos na NR-09 e análise da eficácia das medidas de controle já implementadas;',
        'Riscos ergonômicos incluindo os psicossociais relacionados ao trabalho: análise das exigências das tarefas, carga de trabalho, organização, exigências cognitivas e físicas, considerando também o efeito das ações preventivas adotadas;',
        'Riscos de acidentes: avaliação do grau de exposição do trabalhador ao perigo e análise do desempenho das medidas de controle de acidentes.'
      ]}
    />

    <SubHeading id="8.4">8.4 Classificação e Plano de Ação</SubHeading>
    <Paragraph>
      Com base nos níveis de risco identificados, os riscos ocupacionais são classificados para fins de decisão
      quanto à necessidade de:
    </Paragraph>
    <Bullets
      items={[
        'Implementação, manutenção ou revisão das medidas de prevenção;',
        'Elaboração e priorização do plano de ação de melhorias, com foco na eliminação, redução ou controle eficiente dos riscos inaceitáveis e intoleráveis.'
      ]}
    />

    <Separator weight={15} />
  </View>
)

export default ClassificacaoDosRiscosSection
